import StandardAvatar from '@/components/General/StandardAvatar';
import { useAuth } from '@/providers/AuthProvider';

const CurrentUserAvatar = ({ size = 40 }) => {
  const { user } = useAuth();

  return <StandardAvatar type="user" url={user?.profilePicture?.url} entityId={user?.id} size={size} />;
};

export default CurrentUserAvatar;
